export const LOG_EVENT = 'Event Logged';
export const LOG_ERROR = 'Error Logged';
export const LOG_SUCCESS = 'Success Logged';
